const ACTIVITY_IMAGE_FILES = {
  Reading: "Reading.png",
  Sleeping: "Sleeping.png",
  Playing: "Playing.png",
  Eating: "Eating.png",
  "Snack Time": "Snack time.png",
  Learning: "Learning.png",
  Music: "Music.png",
  Sports: "Sports.png",
  "Bath Time": "Bath.png",
  "Hand Washing": "Handwash.png",
  Brushing: "Brushing.png",
  Painting: "Painting.png",
  Drawing: "Drawing.png",
  Dancing: "Dancing.png",
  Gardening: "Gardening.png",
  "Brain Games": "Brain.png",
  "Quiet Time": "Quite time.png",
};

export function activitySlug(value = "") {
  return String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function findActivityImageFilename(images = []) {
  return (
    (images || []).find((img) =>
      /(?:seed-)?activity-.+\.(?:svg|png)$/i.test(String(img))
    ) || null
  );
}

export function slugFromActivityFilename(filename = "") {
  return String(filename)
    .split("/")
    .pop()
    .replace(/^seed-activity-/, "")
    .replace(/^activity-/, "")
    .replace(/\.(?:svg|png)$/i, "")
    .toLowerCase();
}

function localImageForTitle(title = "") {
  if (!title) return null;
  const exact = ACTIVITY_IMAGE_FILES[title];
  if (exact) return `/images/${exact}`;

  const match = Object.entries(ACTIVITY_IMAGE_FILES).find(
    ([label]) => label.toLowerCase() === String(title).toLowerCase()
  );
  return match ? `/images/${match[1]}` : null;
}

export function getActivityImageSrc(activity, uploadsUrl) {
  if (!activity) return null;

  if (activity.image) {
    const image = String(activity.image);
    if (image.startsWith("http://") || image.startsWith("https://") || image.startsWith("/")) {
      return image;
    }
    return `${uploadsUrl}/${image}`;
  }

  return localImageForTitle(activity.title);
}

export function getPostActivityImageSrc(post, activity, uploadsUrl) {
  const fromActivity = getActivityImageSrc(activity, uploadsUrl);
  if (fromActivity) return fromActivity;

  const seedImage = findActivityImageFilename(post?.images);
  if (seedImage) {
    let filename = String(seedImage).split("/").pop();
    if (filename.startsWith("seed-activity-")) {
      filename = filename.replace(/^seed-activity-/, "activity-");
    }
    return `${uploadsUrl}/${filename}`;
  }

  return null;
}
